import { render, staticRenderFns } from "./editDdtFornitore.vue?vue&type=template&id=537760b4"
import script from "./editDdtFornitore.vue?vue&type=script&lang=js"
export * from "./editDdtFornitore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports